export class InvestorDocument {
    constructor(
        public id: number,
        public name: string,
        public file_types: string,
        public description: string,
        public people_types: string,
        public required: boolean,
        public apply_foreign: boolean

    ) { }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/investorDocument.ts